<template>
  <div>
    <div v-if="!mocId">
      <h3 class="text-h6 ma-5">{{ user.name }} ({{ user.email }})</h3>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import ExternalAuthService from '@/services/external.auth.service'
import ExternalService from '@/services/external.service'

export default {
  name: 'ExternalUser',
  data() {
    return {
      user: {}
    }
  },
  computed: {
    mocId() {
      return this.$route.params.id
    }
  },
  created() {
    ExternalAuthService.getLoggedIn().then(isLoggedIn => {
      if (!isLoggedIn) {
        try {
          localStorage.setItem('emoc.external.loginRedirectUrl', window.location.href)
        } catch(e) { console.log(e) }

        ExternalAuthService.login()
      } else {
        ExternalService.getUserProfile().then(user => {
          this.user = user
        })
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
